export const initialState = {
    surveyEditorOpen: false,
    surveyEditorPosition: {
        x: 100,
        y: 100,
        w: 400,
        h: 500
    },
    surveyResponse: {
        surveyId: "",
        answers: []
    },
    surveyRejected: false,
    surveyReplied: false,
    surveyResponseWindow: false,
    surveyPublished: false,
    surveyState: false,
    survey: {
        title: "Anket başlığı",
        endDate: new Date().toISOString(),
        questions: []
    },
    surveyResults: [
    ]
}

const survey = (state = initialState, action) => {
    switch (action.type) {
        case "SET_SURVEY":
            console.log(action.payload);
            return { ...state, survey: action.payload };
        case "SET_SURVEY_EDITOR_OPEN":
            return { ...state, surveyEditorOpen: action.payload };
        case "SET_SURVEY_EDITOR_POSITION":
            return { ...state, surveyEditorPosition: action.payload };
        case "SET_SURVEY_REJECTED":
            return { ...state, surveyRejected: action.payload };
        case "SET_SURVEY_REPLIED":
            return { ...state, surveyReplied: action.payload };
        case "SET_SURVEY_RESPONSE_WINDOW":
            return { ...state, surveyResponseWindow: action.payload };
        case "SET_SURVEY_EDITOR_PUBLISHED":
            return { ...state, surveyPublished: action.payload };
        case "SET_SURVEY_RESPONSE":
            return { ...state, surveyResults: [...state.surveyResults, action.payload] };
        case "SET_SURVEY_RESPONSE_EMPTY":
            return { ...state, surveyResults: []};
        case "SET_SURVEY_RESPONSE_HISTORY":
            return { ...state, surveyResults: action.payload };
        case "CANCEL_SURVEY":
            return { ...state, survey: initialState.survey };
        case "SET_SURVEY_STATE":
            return { ...state, surveyState: action.payload };
        default:
            return state;
    }
}

export default survey;